// extracted by mini-css-extract-plugin
export default {"form":"styles_form__9z5z3","input":"styles_input__CgRts"};